import React from "react";
import { useFormContext } from "react-hook-form";

import { FormTitle, LineDivider } from "components/layout";
import { AgentType } from "types";

import { PrimarySplitInformationFields } from "../primarySplitInformationFields";
import { WaterfallCalculationMessage } from "../waterfallCalculationMessage";

import styles from "./../../splitProfile.module.scss";

type WaterfallPrimarySplitInformationProps = {
	name: string;
	title: string;
	isLoading: boolean;
	splitInfo: { [key: string]: any };
	currentAgent?: AgentType;
	isEditing: boolean;
};

export const WaterfallPrimarySplitInformation = ({
	name,
	title,
	isLoading = false,
	splitInfo,
	currentAgent,
	isEditing,
}: WaterfallPrimarySplitInformationProps) => {
	const { getValues } = useFormContext();

	const residualsAmountBeforeSplitValue = getValues(
		`${name}.calculation.residualsAmountBeforeSplit`,
	);

	return (
		<div className={`${styles.sectionHolder} ${styles.firstItem}`}>
			<LineDivider />
			<FormTitle>
				<h3>{title}</h3>
			</FormTitle>

			<div className={styles.alertHolder}>
				<WaterfallCalculationMessage
					value={residualsAmountBeforeSplitValue}
					inlineStyles={{ marginLeft: 0 }}
				/>
			</div>
			<PrimarySplitInformationFields
				name={name}
				splitInfo={splitInfo}
				currentAgent={currentAgent}
				isLoading={isLoading}
				isEditing={isEditing}
				isWaterfall={true}
			/>
		</div>
	);
};
